if (!customElements.get('size-guide-drawer')) {
  customElements.define('size-guide-drawer', class extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.size-guide__trigger');
      this.overlay = this.querySelector('.size-guide__overlay');
      this.panel = this.querySelector('.size-guide__panel');
      this.sizeIndex = parseInt(this.dataset.sizeOptionIndex || '0', 10);

      // Move overlay + panel to <body> so position:fixed is not trapped by any
      // transformed/animated ancestor in the product column.
      this.portal = document.createElement('div');
      this.portal.className = 'size-guide-portal';
      this.portal.appendChild(this.overlay);
      this.portal.appendChild(this.panel);
      document.body.appendChild(this.portal);

      this.entries = Array.from(this.panel.querySelectorAll('.size-guide__entry'));
      this.empty = this.panel.querySelector('.size-guide__empty');

      this.trigger.addEventListener('click', () => this.open());
      this.portal.querySelectorAll('[data-size-guide-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.onKey = (e) => { if (e.key === 'Escape') this.close(); };

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const v = event && event.data && event.data.variant;
          if (!v) return;
          const size = this.sizeIndex > 0 ? v['option' + this.sizeIndex] : v.title;
          this.showSize(size);
        });
      }
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.portal && this.portal.parentNode) this.portal.parentNode.removeChild(this.portal);
    }
    showSize(size) {
      let found = false;
      this.entries.forEach((el) => {
        const match = el.dataset.size === size;
        el.hidden = !match;
        if (match) found = true;
      });
      if (this.empty) this.empty.hidden = found;
    }
    open() {
      this.overlay.hidden = false;
      this.panel.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => this.portal.classList.add('size-guide-portal--open')));
      document.body.classList.add('size-guide-lock');
      document.addEventListener('keydown', this.onKey);
      this.panel.focus();
    }
    close() {
      this.portal.classList.remove('size-guide-portal--open');
      document.body.classList.remove('size-guide-lock');
      document.removeEventListener('keydown', this.onKey);
      setTimeout(() => { this.overlay.hidden = true; this.panel.hidden = true; this.trigger.focus(); }, 350);
    }
  });
}
